import { ArgsType, Field } from '@nestjs/graphql'
import { BaseGetArgs } from '../base/baseGet.args'

@ArgsType()
export class UserGetArgs extends BaseGetArgs<UserGetArgs> {
  @Field({ nullable: true })
  needle?: string

  @Field({ nullable: true })
  reported?: boolean

  @Field({ nullable: true })
  topReviewerApplicants?: boolean

  // Publisher accounts whose application waits for review [sc-29190]
  @Field({ nullable: true })
  publisherApplicants?: boolean
}
